/**
 * 块级容器外边框（与 Ant Design 5 `colorBorder`、Card、`ContainerPanel` bordered 一致）。
 * 统计卡片、搜索/表格面板、布局侧栏等「同类容器」统一使用此值。
 */
export var COMPONENT_BORDER_COLOR = "#d9d9d9";
/** 用于 style.border 的完整简写 */
export var COMPONENT_OUTLINE_BORDER = "1px solid ".concat(COMPONENT_BORDER_COLOR);
/**
 * 轻分割线（接近 Ant Design `colorSplit`），用于标题栏下沿等，与外框区分层次。
 */
export var COMPONENT_SPLIT_BORDER_COLOR = "#f0f0f0";
export var COMPONENT_SPLIT_BORDER_BOTTOM = "1px solid ".concat(COMPONENT_SPLIT_BORDER_COLOR);
